import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { SelectableCard } from './selectable-card';
import { getStyles } from './selectable-card-list-styles';

export const SelectableCardList = (props) => {
  const {
    className,
    contents,
    onItemSelected,
    selectedItem,
    useLargeCards,
    classes: overwriteClasses,
    ariaProps,
    accessibleTitle,
  } = props;
  const defaultStyles = useDefaultStyles(getStyles);
  const classes = useMemo(() => ({ ...defaultStyles, ...overwriteClasses }), [defaultStyles, overwriteClasses]);

  return (
    <fieldset
      id={className}
      className={classNames('selectable-card-list', className, classes.cardList)}
      {...ariaProps}
    >
      {accessibleTitle && <legend className={classes.visuallyHidden}>{accessibleTitle}</legend>}
      {_.map(contents, (cardContent, idx) => {
        const {
          id,
          title,
          description,
          footer,
          iconName,
          glyphIconName,
          isDisabled,
          descriptionValue,
        } = cardContent;
        const selected = selectedItem === id;
        return (
          <SelectableCard
            key={id}
            id={id}
            classes={classes}
            title={title}
            description={description}
            descriptionValue={descriptionValue}
            footer={footer}
            selected={selected}
            onClickCard={onItemSelected}
            iconName={iconName}
            glyphIconName={glyphIconName}
            isDisabled={isDisabled}
            useLargeCards={useLargeCards}
            ariaItemSize={contents.length}
            ariaItemIndex={idx + 1}
            name={className}
          />
        );
      })}
    </fieldset>
  );
};

SelectableCardList.propTypes = {
  className: PropTypes.string,
  contents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  })).isRequired,
  onItemSelected: PropTypes.func.isRequired,
  selectedItem: PropTypes.string,
  useLargeCards: PropTypes.bool,
  ariaProps: PropTypes.shape({}),
  classes: PropTypes.shape({}),
};

SelectableCardList.defaultProps = {
  className: undefined,
  selectedItem: null,
  useLargeCards: false,
  ariaProps: undefined,
  classes: null,
};
